import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "table-header" }
const _hoisted_2 = { class: "table-header__columns" }
const _hoisted_3 = ["onClick", "onKeydown"]
const _hoisted_4 = { class: "table-header__column-title" }
const _hoisted_5 = { class: "table-header__search-column" }

import type { SortColumn, SortDirection } from "@virtual-care/shared";

interface Column {
  id: SortColumn;
  title: string;
  sortable: boolean;
}

interface Props {
  sortColumn: SortColumn;
  sortDirection: SortDirection;
  searchQuery: string;
}

interface Emits {
  (e: "sort", column: SortColumn): void;
  (e: "search", query: string): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PatientTableHeader',
  props: {
    sortColumn: {},
    sortDirection: {},
    searchQuery: {}
  },
  emits: ["sort", "search"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const columns: Column[] = [
  { id: "reason", title: "REASON", sortable: true },
  { id: "status", title: "STATUS", sortable: true },
  { id: "diagnosis", title: "PRIMARY DIAGNOSIS", sortable: true },
  { id: "room", title: "ROOM / BED / PATIENT", sortable: true },
];

const getSortIcon = (columnId: SortColumn): string => {
  if (props.sortColumn !== columnId) {
    return "mdi-sort";
  }

  if (props.sortDirection === "ASC") {
    return "mdi-sort-ascending";
  } else if (props.sortDirection === "DESC") {
    return "mdi-sort-descending";
  }

  return "mdi-sort";
};

const handleSort = (columnId: SortColumn) => {
  if (columnId) {
    emit("sort", columnId);
  }
};

const handleSearch = (value: string) => {
  emit("search", value);
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (column) => {
        return _createElementVNode("div", {
          key: column.id,
          class: _normalizeClass(["table-header__column", `table-header__column--${column.id}`]),
          role: "button",
          tabindex: "0",
          onClick: ($event: any) => (handleSort(column.id)),
          onKeydown: [
            _withKeys(($event: any) => (handleSort(column.id)), ["enter"]),
            _withKeys(_withModifiers(($event: any) => (handleSort(column.id)), ["prevent"]), ["space"])
          ]
        }, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(column.title), 1),
          (column.sortable)
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 0,
                size: "16",
                color: __props.sortColumn === column.id ? '#000000' : '#00000061',
                class: "table-header__sort-icon"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(getSortIcon(column.id)), 1)
                ]),
                _: 2
              }, 1032, ["color"]))
            : _createCommentVNode("", true)
        ], 42, _hoisted_3)
      }), 64)),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_v_text_field, {
          "model-value": __props.searchQuery,
          placeholder: " Search Patients",
          variant: "outlined",
          density: "compact",
          "hide-details": "",
          class: "table-header__search-input",
          "onUpdate:modelValue": handleSearch
        }, {
          "append-inner": _withCtx(() => [
            _createVNode(_component_v_icon, {
              size: "16",
              color: "#795DE9"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode("mdi-magnify", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model-value"])
      ])
    ])
  ]))
}
}

})